/**
 * Success component for VulForm
 */

import React from 'react';

interface FormSuccessProps {
  message?: string;
  onReset?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const FormSuccess: React.FC<FormSuccessProps> = ({
  message = 'Thank you! Your message has been sent successfully.',
  onReset,
  className = '',
  style,
}) => {
  return (
    <div className={`vulform-success ${className}`} style={style}>
      <div className='text-center p-4 sm:p-6 border-2 border-green-200 bg-green-50 rounded-lg max-w-full'>
        {/* Success Icon */}
        <div className='mx-auto flex items-center justify-center h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-green-100 mb-3 sm:mb-4'>
          <svg
            className='h-5 w-5 sm:h-6 sm:w-6 text-green-600'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' />
          </svg>
        </div>

        {/* Success Message */}
        <h3 className='text-base sm:text-lg font-semibold text-green-900 mb-2'>Success!</h3>
        <p className='text-sm sm:text-base text-green-800 mb-4 sm:mb-6 leading-relaxed'>
          {message}
        </p>

        {/* Reset Button */}
        {onReset && (
          <button
            onClick={onReset}
            className='inline-flex items-center px-3 py-2 sm:px-4 sm:py-2 border border-transparent text-xs sm:text-sm font-medium rounded-md text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors'
          >
            Send Another Message
          </button>
        )}
      </div>
    </div>
  );
};

export default FormSuccess;
